import React from 'react';
import './App.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import Body from './pages/Body';

function App() {
  return (
    <Router>
      <Body />
    </Router>
  );
}

export default App;
